import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ListItemText from '@material-ui/core/ListItemText';

const Item = ({ title, icon, isbolder, iconStyle, style, noPadding }) => {
  return (
    <ListItem style={{ padding: `${noPadding ? '0px' : '5px 0px 5px 0px'}` }}>
      {icon && (
        <FontAwesomeIcon icon={icon} style={{ ...iconStyle, color: 'black' }} />
      )}
      <ListItemText
        secondaryTypographyProps={{
          style: {
            ...style,
            color: 'black',
            padding: '0px 10px 0px 10px',
            wordBreak: 'break-word',
            fontWeight: isbolder && 'bolder',
            width: '100%'
          }
        }}
        secondary={title}
      />
    </ListItem>
  );
};

export default Item;
